// redux/slices/envSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  baseUrl: process.env.REACT_APP_BASE_URL,  // Load from environment variables
  prodTestUrl: process.env.REACT_APP_PROD_TEST_URL,
  isProduction: process.env.IS_PRODUCTION,
};

const envSlice = createSlice({
  name: "env",
  initialState,
  reducers: {},
});

export const selectBaseUrl = (state) => state.env.baseUrl;
export const selectProdTestUrl = (state) => state.env.prodTestUrl;
export const selectProdBoolean = (state) => state.env.isProduction;

export default envSlice.reducer;
